import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { OrdersWrapper } from '@/widgets/cart/OrdersWrapper';

import { ContentHeader } from '@/features/cart/ContentHeader';

import { getIsCartEmpty, loadCartData } from '@/entities/cart';

import { APP_ELEMENTS } from '@/shared/constants';
import { useAppDispatch, useAppSelector } from '@/shared/hooks/appRedux';
import { getLoading } from '@/shared/services/loading';
import { LoadingBackground } from '@/shared/services/modal';
import { BasketPreiewAction } from '@/shared/utils/basketPreiew';

import { EmptyText, Wrapper } from './parts';

const CartPage: React.FC = () => {
  const loading = useAppSelector(getLoading);
  const isCartEmpty = useAppSelector(getIsCartEmpty);
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch<CartAppDispatch>();
  useEffect(() => {
    dispatch(loadCartData(window.cart));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isCartEmpty) {
    BasketPreiewAction();
  }
  return (
    <>
      {!isCartEmpty && (
        <Wrapper className="WrapperCart">
          <ContentHeader />
          <OrdersWrapper />
        </Wrapper>
      )}
      {isCartEmpty && (
        <EmptyText
          className="WrapperEmpty"
          dangerouslySetInnerHTML={{
            __html: formatMessage({ id: 'Checkout.Cart.Labels.EmptyBasketLabel' }),
          }}
        />
      )}
      <LoadingBackground loading={loading} appElement={APP_ELEMENTS.CART} />
    </>
  );
};
export default CartPage;
